var React = require( 'react' );
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var DropDownList = require('./dropDownList.jsx');

var YearPicker = createReactClass({

  loadYears: function(startYear) {
    var currentYear = new Date().getFullYear();
    var years = [];
    startYear = startYear || 1900;

    for(var i=currentYear; i >= startYear; i--) {
      var year = {"id": i, "value": i, "title": i}
      years.push(year);
    };

    return years;
  },

  render: function(){
    var yearsList = this.loadYears(this.props.startYear);
    return (
        <DropDownList value={this.props.year} list={yearsList} onChange={this.props.onYearChange} />
    );
  }
});

YearPicker.propTypes = {
  startYear: PropTypes.string.isRequired
};

module.exports = YearPicker;



// WEBPACK FOOTER //
// ./src/common/routes/components/yearPicker.jsx